import { TextAreaMinRows } from "immigram-ui-cmon/src/components/TextArea/TextArea";
import clsxm from "immigram-ui-cmon/src/lib/clsxm";
import isString from "lodash/isString";
import React from "react";
import { Control } from "react-hook-form";

import { ValidationError } from "@/lib/hook/useValidation";

import ControlledTextAreaWithInlineHelp from "@/components/FormElements/ControlledTextAreaWithInlineHelp";

import {
  ConfigParamValueWithModifiers,
  ImmigramFormElementConfigBase,
  ImmigramFormElementOnChange,
  ImmigramFormElementType,
  useModifiedConfigParamValue,
} from "./common";

export interface ImmigramFormElementConfigTextarea
  extends ImmigramFormElementConfigBase {
  type: ImmigramFormElementType.Textarea;
  name: string;
  heading?: ConfigParamValueWithModifiers;
  title?: ConfigParamValueWithModifiers;
  placeholder?: string;
  example?: ConfigParamValueWithModifiers;
  description?: ConfigParamValueWithModifiers;
}

interface ImmigramFormTextareaProps {
  elementConfig: ImmigramFormElementConfigTextarea;
  control: Control;
  onChange: ImmigramFormElementOnChange;
  disabled: boolean;
  commentThreadId?: string;
  validationErrors?: ValidationError | null;
  withComments?: boolean;
}

function ImmigramFormTextarea({
  elementConfig,
  control,
  onChange,
  disabled,
  commentThreadId,
  validationErrors,
  withComments,
}: ImmigramFormTextareaProps) {
  const heading = useModifiedConfigParamValue(elementConfig.heading);
  const title = useModifiedConfigParamValue(elementConfig.title);
  const placeholder = useModifiedConfigParamValue(elementConfig.placeholder);
  const example = useModifiedConfigParamValue(elementConfig.example);
  const description = useModifiedConfigParamValue(elementConfig.description);

  return (
    <div className="grid grid-cols-12 gap-8">
      <ControlledTextAreaWithInlineHelp
        className={clsxm(
          "pl-[1px]",
          withComments && !commentThreadId ? "col-span-7" : "col-span-12"
        )}
        heading={heading}
        description={description}
        control={control}
        fieldName={elementConfig.name}
        placeholder={
          isString(placeholder) ? placeholder : elementConfig.placeholder
        }
        commentThreadId={commentThreadId}
        label={title || "Description"}
        example={example}
        fullExample
        minRows={TextAreaMinRows.MultiLine}
        onChange={onChange}
        disabled={disabled}
        error={validationErrors?.message}
      />
    </div>
  );
}

export { ImmigramFormTextarea };
